import type { RefreshResponse, RefreshResponseItem } from '../../../types/items.api';
import type { SubItem } from '../../../types/sub-item.types';

export interface DuplicatePartGroup {
   key: string;
   part: string;
   partDetail: string;
   oldPart: SubItem;
   newPart: SubItem;
}

export const getSucceededRefreshItems = (response: RefreshResponse): RefreshResponseItem[] =>
   Object.values(response.items)
      .flat()
      .filter((item) => item.status);

export const getSucceededItemNos = (response: RefreshResponse): string[] => getSucceededRefreshItems(response).map((item) => item.itemNo);

export const findDuplicateParts = (subItems: SubItem[]): DuplicatePartGroup[] => {
   const groups = new Map<string, SubItem[]>();

   subItems.forEach((subItem) => {
      if (!subItem.active) {
         return;
      }
      const key = `${subItem.partDetail ?? ''}::${subItem.part}::${subItem.materialGrade ?? ''}`;
      const existing = groups.get(key) || [];
      existing.push(subItem);
      groups.set(key, existing);
   });

   const duplicates: DuplicatePartGroup[] = [];

   groups.forEach((items, key) => {
      if (items.length < 2) {
         return;
      }

      const newParts = items.filter((i) => i.newFromPia);
      const oldParts = items.filter((i) => !i.newFromPia);
      if (newParts.length === 0 || oldParts.length === 0) {
         return;
      }

      const usedOldIds = new Set<number>();

      newParts.forEach((newPart) => {
         const matchingOld = oldParts.find((old) => !usedOldIds.has(old.id));
         if (matchingOld) {
            usedOldIds.add(matchingOld.id);
            duplicates.push({
               key: `${key}::${newPart.id}`,
               part: newPart.part,
               partDetail: newPart.partDetail,
               oldPart: matchingOld,
               newPart,
            });
         }
      });
   });

   return duplicates;
};
